import React from 'react';
import { getPartnersLevels } from '~helpers/constant'

export const Levels: React.FC = () => {
  const partnersLevels = getPartnersLevels()

  return (
    <div className='onlinepbx__partners__levels'>
      <div className='onlinepbx__container'>
        <h2 className='onlinepbx__partners__levels__header'>
          2 уровня дохода на все продукты телефонии
        </h2>
        <div className='onlinepbx__partners__levels__content'>
          {Object.values(partnersLevels).map(level => {
            return (
              <div
                key={level.color}
                className='onlinepbx__partners__levels__block'>
                <div
                  className='onlinepbx__partners__levels__background'
                  style={{ background: level.color }} />
                {ProgressBar(level.value, level.percent)}
                <div className='onlinepbx__partners__levels__text'>
                  <div className='onlinepbx__partners__levels__name'>
                    {level.name}
                  </div>
                  <div className='onlinepbx__partners__levels__description'>
                    {level.description}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

const ProgressBar: React.FC<Number> = (value, percent) => {
    return (
        <div className='onlinepbx__progress'>
      <svg
        className='onlinepbx__progress__svg'
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-1 -1 34 34">
        <circle
          cx="16"
          cy="16"
          r="15.9155"
          className="onlinepbx__progress__background"
        />
        <circle
          cx="16"
          cy="16"
          r="15.9155"
          strokeDasharray={`${percent} 100`}
          className="onlinepbx__progress__progress"
        />
      </svg>
      <div className='onlinepbx__progress__text'>
        {value.toString()}%
      </div>
    </div>
  )
}

export default Levels
